export default {
  clubJoinBanner: {},
  showJoinClubModal: false,
  pointsHistory: false,
}
